import { Box, SxProps } from '@mui/material';
import { useStore } from '@priolo/jon';
import SelectorScopeGroupH from 'components/controls/select/SelectorScopeGroupH';
import SelectorScopeH from 'components/controls/select/SelectorScopeH';
import { FunctionComponent } from 'react';
import querySo from "stores/route/query";
import { URL_PAR } from 'stores/route/utils/types';



interface Props {
	sx?: SxProps
}

const SelectorScopeAndGroupH: FunctionComponent<Props> = ({
	sx,
}) => {

	// STORE
	useStore(querySo)

	// HOOKs

	// HANDLERs
	const handleScopeChange = (scope: string) => {
		querySo.setSearchUrl([URL_PAR.SCOPE_FIL, scope, URL_PAR.SCOPE_GROUP_FIL, null])
	}
	const handleGroupChange = (group: string) => {
		querySo.setSearchUrl([URL_PAR.SCOPE_GROUP_FIL, group])
	}

	// RENDER
	const [scopeSel, groupSel] = querySo.getSearchUrl([
		URL_PAR.SCOPE_FIL, URL_PAR.SCOPE_GROUP_FIL,
	])

	return <Box sx={[{ display: "flex" }, sx] as SxProps}>
		
		<SelectorScopeH sx={{ mr: 1 }}
			scope={scopeSel}
			onChange={handleScopeChange}
		/>

		<SelectorScopeGroupH sx={{ mr: 1 }}
			scope={scopeSel}
			group={groupSel}
			onChange={handleGroupChange}
		/>
		
	</Box>
}

export default SelectorScopeAndGroupH
